import { render } from "./ScreenQuestionsTrueFalse.vue?vue&type=template&id=1acfa6b3&scoped=true&ts=true"
import script from "./ScreenQuestionsTrueFalse.vue?vue&type=script&lang=ts"
export * from "./ScreenQuestionsTrueFalse.vue?vue&type=script&lang=ts"

import "./ScreenQuestionsTrueFalse.vue?vue&type=style&index=0&id=1acfa6b3&scoped=true&lang=scss"

import exportComponent from "/Users/matejvehar/git/mvehar/pi-slidoos/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1acfa6b3"]])

export default __exports__